import { Home } from "lucide-react";
import { AT_HOME } from "@/lib/practiceCopy";

/** "No equipment needed. Practise at home." One small card, reused wherever someone decides whether to try it. */
export default function AtHomeNote({ kind = "general", className = "" }) {
  return (
    <div className={`flex gap-3 rounded-xl border border-lime-400/25 bg-lime-400/5 px-3.5 py-3 ${className}`} data-testid="at-home-note">
      <Home className="w-4 h-4 mt-0.5 shrink-0 text-lime-400" aria-hidden="true" />
      <p className="text-[14px] leading-snug text-zinc-300"><strong className="text-white">{AT_HOME.title}</strong> {AT_HOME[kind] || AT_HOME.general}</p>
    </div>
  );
}
